import { useEffect, useState } from "react";

/* One implementation of the reduced-motion question, shared by every surface
 * that asks it. Starts `false` so the server/prerender pass and the first
 * client frame agree; the effect corrects it before anything animates. */
export function useReducedMotion() {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const onChange = (e) => setReduced(e.matches);
    // Safari < 14 only has the deprecated form.
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return reduced;
}

export default useReducedMotion;
